import script from "./DropdownMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./DropdownMenu.vue?vue&type=script&lang=ts&setup=true"

import "./DropdownMenu.vue?vue&type=style&index=0&id=5eaab650&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eaab650"]])

export default __exports__